<ng-container *ngIf="product$ | async as product">
  <ng-container *ngIf="product.potentialPromotions">
    <cx-promotions
      *cxFeature="'showPromotionsInPDP'"
      [promotions]="product.potentialPromotions"
    ></cx-promotions>
  </ng-container>
  <div class="gonvarri-product-summary__price-header" *ngIf="getVolumePricesLenght(product) > 0 && !isContract(product)">
    <span>{{ 'gonvarri.productSummary.quantity' | cxTranslate }}</span>
    <span>{{ 'gonvarri.productSummary.price' | cxTranslate }}</span>
  </div>
  <ng-template
    [cxOutlet]="outlets.PRICE"
    [cxOutletContext]="{ product: product }"
    *ngIf="getVolumePricesLenght(product) === 0 || isContract(product)"
  >
    <div
      [attr.aria-label]="'productSummary.newItemPrice' | cxTranslate"
      class="price"
    >
      {{product.price?.formattedValue}}
    </div>
  </ng-template>
  <ng-container
    *ngIf="!isContract(product)">
    <ng-template
      [cxOutlet]="outlets.PRICE"
      [cxOutletContext]="{ product: product }"
      *ngFor="let price of product.volumePrices"
    >
      <div
        [attr.aria-label]="'productSummary.newItemPrice' | cxTranslate"
        class="price"
      >
        <span>{{ formatPriceMinQuantity(price.minQuantity ?? 0) }}{{ price.maxQuantity ? '-' : '' }}{{price.maxQuantity ? formatPriceMaxQuantity(price.maxQuantity) : ' +'}} Tm</span>
        <span>{{ price.formattedValue }}{{getPriceComplement()}}</span>
      </div>
    </ng-template>
  </ng-container>
  <ng-template
    [cxOutlet]="outlets.SUMMARY"
    [cxOutletContext]="{ product: product }"
  >
    <p [innerHTML]="product?.summary" class="summary"></p>
  </ng-template>
</ng-container>
